import { useAppSelector } from '@/store/hooks'
import { selectIsGuestModified } from '@/store/ui/uiSelectors'
import { selectAuth } from '@/store/auth/authSelectors'
import { TextMidd } from '@/components/ui/Text'
import css from './SidebarSavePopup.module.css'

const SidebarSavePopup = () => {
    const auth = useAppSelector(selectAuth)
    const isGuestModified = useAppSelector(selectIsGuestModified)

    if (auth || !isGuestModified) return null

    return (
        <div className={css.popup}>
            <TextMidd className={css.text}>This is a demo project. Changes won’t be saved.</TextMidd>
        </div>
    )
}

export default SidebarSavePopup
